import $ from 'jquery';
import navbar from './sustainability-navbar';

export default () => {
    // Carousels
    const navText = [
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.52868 11.1332C5.78903 11.3936 6.21114 11.3936 6.47149 11.1332C6.73184 10.8729 6.73184 10.4508 6.47149 10.1904L2.94281 6.66174L10.6666 6.66174C11.0348 6.66174 11.3333 6.36327 11.3333 5.99508C11.3333 5.62689 11.0348 5.32841 10.6666 5.32841L2.94297 5.32841L6.47149 1.79989C6.73184 1.53955 6.73184 1.11744 6.47149 0.857086C6.21114 0.596736 5.78903 0.596736 5.52868 0.857086L0.872768 5.513C0.745723 5.63438 0.666585 5.80549 0.666585 5.99508C0.666585 6.18235 0.743806 6.35159 0.868144 6.47269L5.52868 11.1332Z"/></svg>',
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.47145 0.857005C6.2111 0.596656 5.78899 0.596656 5.52864 0.857005C5.26829 1.11735 5.26829 1.53946 5.52864 1.79981L9.05731 5.32849L1.33329 5.32849C0.965103 5.32849 0.666626 5.62697 0.666626 5.99516C0.666626 6.36335 0.965103 6.66182 1.33329 6.66182L9.05715 6.66182L5.52864 10.1903C5.26829 10.4507 5.26829 10.8728 5.52864 11.1331C5.78899 11.3935 6.2111 11.3935 6.47145 11.1331L11.1377 6.46692L11.1381 6.46648M11.1395 6.46511C11.3985 6.20465 11.398 5.78356 11.1381 5.52367L6.47145 0.857005"/></svg>'
    ];

    $('.js-sustainability-carousel').each(function() {
        $(this).owlCarousel({
            nav: true,
            navContainer: $(this).parent().find('.js-sustainability-carousel-nav'),
            navText,
            items: 1,
            margin: 30,
            dots: false
        });

        $(this).on('changed.owl.carousel', function(e) {
            const $pagination = $(this).parent().find('.js-sustainability-carousel-pagination-page');
            $pagination.text(e.item.index + 1);
        });
    });

    $('.js-sustainability-card-carousel').each(function() {
        $(this).owlCarousel({
            nav: true,
            navContainer: $(this).parent().parent().find('.js-sustainability-card-carousel-nav'),
            navText,
            items: 1,
            margin: 30,
            dots: false,
        });
    });

    $('.js-sustainability-goal-carousel').each(function() {
        $(this).owlCarousel({
            nav: true,
            navContainer: $(this).parent().find('.js-sustainability-goal-carousel-nav'),
            navText,
            items: 1,
            margin: 30,
            dots: false,
            responsive: {
                768: {
                    items: 3
                }
            }
        });
    });

    $('.js-sustainability-feature-goal-carousel').each(function() {
        $(this).owlCarousel({
            nav: true,
            navContainer: $(this).parent().find('.js-sustainability-feature-goal-carousel-nav'),
            navText,
            items: 1,
            margin: 30,
            dots: false,
            responsive: {
                768: {
                    items: 2
                }
            }
        });
    });

    // Navbar
    navbar();
}
